export default __webpack_public_path__ + "static/media/br-banner.e4de4cb9.png";